import React from "react";

export const X = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <g clipPath="url(#clip0_778_180)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6667 14C14.4154 14 14.1856 14.1412 14.072 14.3653C13.9584 14.5894 13.9805 14.8583 14.1291 15.0609L18.3036 20.7536L14.1953 24.8619C13.9349 25.1223 13.9349 25.5444 14.1953 25.8047C14.4556 26.0651 14.8777 26.0651 15.1381 25.8047L19.1013 21.8415L21.9511 25.7276C22.0766 25.8988 22.2763 26 22.4887 26H25.3333C25.5846 26 25.8144 25.8588 25.928 25.6347C26.0416 25.4106 26.0195 25.1417 25.8709 24.9391L21.6964 19.2464L25.8047 15.1381C26.0651 14.8777 26.0651 14.4556 25.8047 14.1953C25.5444 13.9349 25.1223 13.9349 24.8619 14.1953L20.8987 18.1585L18.0489 14.2724C17.9234 14.1012 17.7237 14 17.5113 14H14.6667ZM22.8265 24.6667L15.9823 15.3333H17.1735L24.0178 24.6667H22.8265Z"
          fill="#6C3BC7"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_778_180">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
